fx.ns("requests", class OldUploadRequest extends fx.Service
{
    constructor(data)
    {
        super();

        this.model = data;

        this._uploadFileProgressHandler = this._uploadFileProgress.bind(this);
    }

    get currentFile()
    {
        return this._currentFile;
    }

    uploadFile(url, file)
    {
        this.trigger("photo-upload-started", this);

        this._currentFile = file;
        
        this._currentFile._upload.uploading = true;
        this._currentFile._upload.uploaded = false;
        this._currentFile._upload.tries++;
                                            
        var formData = new FormData();
        // fix problem when register after uploading pictures
        formData.append('accountid', this.model.account.id);

        for(let property in this._currentFile.uploadParams)
            if (property != "mediatype")
                formData.append( property, this._currentFile.uploadParams[property] );
            
        if (this._currentFile.social)
        {
            formData.append( "mediatype", "social" );
            formData.append( "socialmedia", this._currentFile.social );
            formData.append( "url", this._currentFile.media_url );
        }
        else
        {
            formData.append( "mediatype", this._currentFile.uploadParams["mediatype"] );
            formData.append('file', this._currentFile.file);
        }

        this.post(url, formData, this._uploadFile, {processData: false,  contentType: false, timeout : 600000, progressCallBack : this._uploadFileProgressHandler, maxTries : 1 });
    }

    _uploadFile(result)
    {
        if (!result.error && result.id)
        {
            this._currentFile._upload.loaded = this._currentFile._upload.size || fx.get("settings").socialFileSize;
            this._currentFile._upload.uploading = false;
            this._currentFile._upload.uploaded = true;

            if (this._currentFile._upload.toResend)
            {
                this._currentFile.cancel(result.id);
                this._currentFile._upload.toResend = false;
            }
            else
            {
                Utils.temporaryId(this._currentFile.id, result.id);
                
                this._currentFile.prop("oldid", this._currentFile.id);

                this._currentFile.clean();

                this._currentFile.update({
                                    id : result.id,
                                    hash : this._currentFile.id,
                                    width : result.width,
                                    height : result.height,
                                    number : this._currentFile.number, // so we force update this value in case it was updated while photo was uploading
                                    deleted : this._currentFile.deleted, // -- same
                                    faces : this._currentFile.faces, // -- same
                                    average_color : this._currentFile.average_color,
                                    thumb : Utils._fixURL(result.thumb),
                                    url : Utils._fixURL(result.url),
                                    light_url : Utils._fixURL(result.url)
                                });

                this._currentFile.event("media-file-uploaded");
            }

            this.trigger("photo-upload-finished", this);
        }
        else
        {
            //this._currentFile._upload.lastError = result;
            this._currentFile._upload.uploading = false;
            this._currentFile._upload.uploaded = false;
            this._currentFile._upload.loaded = 0;

            this.trigger("photo-upload-error", this);
        }        
    }

    _uploadFileProgress(loaded, total)
    {
        if (this._currentFile.file && this._currentFile.file.size )
           this._currentFile._upload.loaded = loaded;

        this._currentFile.event("upload-file-progress");

        this.trigger("photo-upload-progress", this);
    }

});
    